export default function ClearwaterTravelTimingSection() {
  const seasons = [
    {
      icon: "ri-flag-line",
      title: "Spring Training Season",
      months: "February – March",
      description:
        "The Philadelphia Phillies occupy Spectrum Field in downtown Clearwater, while the Toronto Blue Jays play in nearby Dunedin. Thousands of Canadian and Northeast snowbird fans arrive for spring training — many continuing north to Toronto for regular-season games. Passport demand spikes as baseball travelers realize they need valid documents for cross-border trips.",
      alert: "Spring training fans often book Toronto trips after camp ends. Check your passport's Canada validity before booking flights.",
    },
    {
      icon: "ri-sun-line",
      title: "Spring Break & Beach Season",
      months: "March – April",
      description:
        "Clearwater Beach becomes ground zero for spring breakers from across the Southeast and Midwest, plus families escaping Northern winters. College students and families alike often book last-minute Cancun, Jamaica, or Bahamas trips when Florida crowds peak. This is our busiest season for emergency child and student passport requests.",
      alert: "Last-minute spring break trips to Mexico or the Caribbean are common. Child passports take longer — start 8–10 weeks early.",
    },
    {
      icon: "ri-ship-line",
      title: "Summer Cruise & International Peak",
      months: "June – August",
      description:
        "Summer brings peak international travel for Clearwater families. Caribbean cruises depart daily from the Port of Tampa, just 25 miles away. European vacation packages, student study-abroad programs, and family trips to the UK and Ireland fill our processing queue. Tampa International's direct flights to London, Frankfurt, and Zurich make Europe surprisingly accessible.",
      alert: "Summer is peak passport season nationwide. Book expedited service early even with our rush options — slots fill fast.",
    },
    {
      icon: "ri-snowy-line",
      title: "Snowbird Migration & Reverse Travel",
      months: "November – April",
      description:
        "Clearwater's snowbird population — Canadians and Northeasterners who winter here — creates a unique seasonal demand pattern. In November, they arrive. In April and May, they reverse-migrate north, often continuing to Toronto, Montreal, or overseas. Many snowbirds discover dormant passports expired over the Florida winter.",
      alert: "Snowbirds: check your passport before leaving Florida for summer travel. A passport stored in a beach condo safe for six months may have expired unnoticed.",
    },
  ];

  return (
    <section id="travel-timing" className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Travel Calendar
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            When Clearwater Residents Travel — and When to Renew
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Clearwater's travel calendar revolves around spring training, spring break beach crowds,
            summer cruises from Tampa, and the seasonal snowbird migration. Plan your passport renewal
            around these peak windows.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {seasons.map((season, i) => (
            <div key={i} className="bg-white rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 rounded-lg bg-[#1A365D] flex items-center justify-center shrink-0">
                  <i className={`${season.icon} text-white text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-serif text-base font-bold text-[#1A365D]">{season.title}</h3>
                  <p className="text-[#B22222] text-xs font-semibold mt-0.5">{season.months}</p>
                </div>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">{season.description}</p>
              <div className="flex items-start gap-2 bg-[#F6C344]/10 rounded-lg p-3">
                <i className="ri-error-warning-line text-[#B22222] text-sm mt-0.5 shrink-0"></i>
                <p className="text-gray-700 text-xs leading-relaxed">{season.alert}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Quick timing tips */}
        <div className="mt-10 bg-white rounded-lg border border-gray-100 p-6 md:p-8">
          <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-6 flex items-center gap-2">
            <i className="ri-calendar-check-line text-[#F6C344]"></i>
            Clearwater Traveler Timing Cheat Sheet
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { label: "Phillies Spring Training", tip: "Check passport before booking Toronto post-camp trip — 4+ months early" },
              { label: "Spring Break (Cancun/Jamaica)", tip: "Child passports need 8–10 weeks. Adults: 6–8 weeks minimum" },
              { label: "Tampa Caribbean Cruise", tip: "Some Bahamas cruises accept birth certificates, but passports are safer" },
              { label: "Europe Summer Trip", tip: "Schengen rule: passport valid 3+ months past return date" },
              { label: "Canada Summer Visit", tip: "No visa required, but passport must be valid for entry" },
              { label: "PIE Allegiant Connection", tip: "PIE has no customs — international trips require TPA or another gateway" },
            ].map((item, i) => (
              <div key={i} className="bg-[#F8F9FB] rounded-lg p-4">
                <p className="text-[#1A365D] font-semibold text-xs mb-1">{item.label}</p>
                <p className="text-gray-600 text-xs leading-relaxed">{item.tip}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}